export enum GiftCardFormFields {
  GC_NUM = 'gcNum',
  GC_AUTH = 'gcAuth',
  FORM_ERROR = 'giftCardNumberAndAuthNumber',
  GENERIC_ERROR = 'GENERIC_ERROR',
}
